<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <b-form-textarea
                id="textarea"
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :placeholder="field.placeholder"
                rows="3"
                max-rows="3"
                :disabled="loading"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends
}
</script>
